import { render, staticRenderFns } from "./faqSelector.vue?vue&type=template&id=52afc472&"
import script from "./faqSelector.vue?vue&type=script&lang=js&"
export * from "./faqSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports